import type { FaireProductEntity } from "../../entity_types/product";

export const p_32h8kpx8yc: FaireProductEntity = {
  token: "p_32h8kpx8yc",
  type: "product",
  name: "Tie-Dye Pants (KT-1422)",
  brandToken: "b_a990dearj1",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/723a556e401cdae389c166f4aa45c144b1031a7ecee31b057b48cee9a538385c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d114392f611a579c1fc87b1b08aac065fc4ea91a384e0953ab56de1e38460e8.jpeg",
    "https://cdn.faire.com/fastly/d310cda0ac582ec2f633d8cbfc16f45a074104b741897d1312c5594afc8768e8.jpeg",
    "https://cdn.faire.com/fastly/92061f48a4474179b181aace0f4b6bdda7bda22623024a9ba66f54b9109ef5ed.jpeg",
    "https://cdn.faire.com/fastly/0358f094efb7cba48134fca0c543a58f8563bcdb85f7e0ab795bcd83432f9379.jpeg",
    "https://cdn.faire.com/fastly/c6d59bd1295b339eed50fd43db5b79a65e57e7da719c56ece75bb56e8ff784b3.jpeg",
    "https://cdn.faire.com/fastly/39325e0b4a1d54d9935be5b07b4266186b1432c160773e40167e5a4fbd4ab000.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "Our Kathmandu Imports Tie-Dye Elastic Waist Pants offer a unique blend of comfort and style. Made from 100% Rayon, these pants are perfect for everyday wear, whether you're running errands or lounging at home. The casual aesthetic is complemented by a vibrant tie-dye design, and the elastic waist and side pockets add practicality. Suitable for Spring/Summer season.",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:17.375Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
